import { vivasamApi } from '../api/common';
import { publishedBoxApi } from '../api/sets/publish';
import { usePersistStore } from '../lib/store';
import { isVisibleClassStudent } from './publish';

interface BaseParams {
    publishGrpId: number;
}

interface NormalParams extends BaseParams {
    type: 'normal';
    studentList: DATA.TagItem[];
}

interface RepublishParams extends BaseParams {
    type: 'republish';
    studentList: DATA.StntInfoType[];
}

type Params = NormalParams | RepublishParams;

export const vivaClassEvalSave = async (options: Params) => {
    const { sUserId, sVivaToken, memberList, sDefaultUserId, sMyClassMemberList } =
        usePersistStore.getState();
    const { publishGrpId, type, studentList } = options;

    const publishGrpData = await publishedBoxApi.getIntegPubCompleteList({
        publishGrpId: publishGrpId,
    });

    if (!publishGrpData) return;

    const publishIds = publishGrpData?.examList.flatMap((exam) =>
        exam.publishList.map((p) => p.publishId)
    );
    const vivaClassDataList: API.EvaluateSave.Params[] = [];

    for (const v of publishIds) {
        const res = await publishedBoxApi.getPublishDetail({
            wrterId: sUserId,
            publishId: v,
        });
        if (!res || !res.publishInfoDetail) continue;
        if (type === 'normal') {
        }
        // studentList 와 sMyClassMemberList 기반 데이터 필터링
        const studentIdList: string[] = [];
        const classSeq = Number(res.publishInfoDetail.claId.split('-')[4]);
        const classMembers =
            sMyClassMemberList?.find((item) => item.classInfo.classSeq === classSeq)?.memberInfo ??
            memberList;
        if (type === 'normal') {
            const filterSelectClass = studentList?.find(
                (item) => item.claId?.split('-')[4] === res.publishInfoDetail?.claId?.split('-')[4]
            );
            const filterStudentIdList =
                filterSelectClass?.stdtUserInfo?.map((u) => u.stdtUserId) ?? [];

            filterStudentIdList.forEach((id) => {
                const find = classMembers?.find(
                    (member) =>
                        member.orgMemberId?.split('M')[0] === id?.split('-')[0] &&
                        isVisibleClassStudent(member)
                );
                if (find) {
                    studentIdList.push(find.orgMemberId);
                }
            });
        } else {
            const filterStudentIdList = studentList?.map((u) => u.stdtUserId) ?? [];
            filterStudentIdList.forEach((id) => {
                const find = classMembers?.find(
                    (member) =>
                        member.orgMemberId?.split('M')[0] === id?.split('-')[0] &&
                        isVisibleClassStudent(member)
                );
                if (find) {
                    studentIdList.push(find.orgMemberId);
                }
            });
        }

        const vivaClassData = {
            publishId: res.publishInfoDetail.publishId?.toString(),
            setsId: res.publishInfoDetail.setsId,
            publishNm: res.publishInfoDetail.publishNm,
            publishUse: res.publishInfoDetail.publishUse,
            pdPublishStDt: res.publishInfoDetail.pdPublishStDt,
            pdPublishEdDt: res.publishInfoDetail.pdPublishEdDt,
            sttsNm: res.publishInfoDetail.sttsNm,
            checkStts: res.publishInfoDetail.checkStts,
            targetCnt: res.publishInfoDetail.targetCnt,
            submitCnt: res.publishInfoDetail.submitCnt,
            claId: res.publishInfoDetail.claId,
            examId: res.publishInfoDetail.examId,
            publishType: res.publishInfoDetail.publishType?.toString(),
            trgtId: res.publishInfoDetail.trgtId,
            hintOnOff: res.publishInfoDetail.hintOnOff,
            timTime: res.publishInfoDetail.timTime,
            teacherId: sDefaultUserId,
            classSeq,
            // status: 0,
            // allStudentYn: 'Y',
            realTimeYn:
                !res.publishInfoDetail.pdPublishStDt || !res.publishInfoDetail.pdPublishEdDt
                    ? 'Y'
                    : 'N',
            curriBook: res.publishInfoDetail.curriBook?.toString(),
            curriBookCd: res.publishInfoDetail.curriBookCd,
            curriBookNm: res.publishInfoDetail.curriBookNm,
            subjectNm: res.publishInfoDetail.curriSubjectVal,
            studentList: studentIdList ?? [],
        };
        vivaClassDataList.push(vivaClassData);
    }

    const evalSave = await vivasamApi.postEvaluateSave(
        { requests: vivaClassDataList },
        sVivaToken!
    );
};

type EvaluateUpdateType = {
    publishId: string;
    teacherId: string;
    classSeq: number;
    studentList?: string[];
    pdSetAt?: FlagYn;
    pdPublishStDt?: string;
    pdPublishEdDt?: string;
    timStAt?: FlagYn;
    timTime?: string;
};

export const vivaClassEvalUpdate = async (options: EvaluateUpdateType) => {
    const { sVivaToken } = usePersistStore.getState();
    const {
        publishId,
        teacherId,
        classSeq,
        studentList,
        pdSetAt,
        pdPublishStDt,
        pdPublishEdDt,
        timStAt,
        timTime,
    } = options;

    const res = await vivasamApi.postEvaluateUpdate(
        {
            publishId,
            teacherId,
            classSeq,
            studentList,
            pdSetAt,
            pdPublishStDt,
            pdPublishEdDt,
            timStAt,
            timTime,
        },
        sVivaToken!
    );

    return res;
};

export async function upsertEvaluateRecordsByTargets(opts: {
    targetIds: string[];
    evlId: string | number;
    sVivaToken: string;
    buildPayload: () => {
        // 공통으로 넣을 값. 예: contents, semester, category 등
        teacherId: string;
        classSeq: number;
        contents: string;
        category?: string; // 예: "EVALUATE_RECORD"
        // ... 추가 필드
    };
}) {
    var targetIds = opts.targetIds || [];
    var evlIdStr = String(opts.evlId);
    for (var i = 0; i < targetIds.length; i++) {
        var targetId = targetIds[i];
        var base = opts.buildPayload();

        // 1) 리스트 조회
        var listRes = await vivasamApi.postRecordList(
            {
                // 실제 쿼리 스펙에 맞게 세팅(아래는 예시)
                teacherId: base.teacherId,
                // page: 0,
                recordSize: 9999,
                classSeq: base.classSeq,
                studentId: targetId?.split('M')[0],
                category: 'EVALUATE_RECORD',
            } as any,
            opts.sVivaToken
        );

        var list = listRes.data && listRes.data.response.list ? listRes.data.response.list : [];

        // 2) 동일 evlId 레코드 탐색 (여러 개면 최신 한 건)
        var same = list.filter(function (r: API.REPORT.TCH.RecordList.RecordItem) {
            return String(r.evlId) === evlIdStr;
        });
        var existing: API.REPORT.TCH.RecordList.RecordItem | null = null;
        if (same.length > 0) {
            same.sort(function (a, b) {
                var ax = a.regDttm || '';
                var bx = b.regDttm || '';
                // 문자열 비교: 최신이 먼저 오도록 내림차순
                return ax < bx ? 1 : ax > bx ? -1 : 0;
            });
            existing = same[0];
        }

        // 3) 있으면 수정, 없으면 추가
        if (existing) {
            await vivasamApi.postRecordUpdate(
                Object.assign(
                    {
                        recordId: existing.recordId,
                        category: 'EVALUATE_RECORD',
                    },
                    base
                ) as any,
                opts.sVivaToken
            );
        } else {
            await vivasamApi.postRecordMultipleInsert(
                Object.assign(
                    {
                        studentIds: [targetId],
                        evlId: Number(opts.evlId),
                        category: 'EVALUATE_RECORD',
                    },
                    base
                ) as any,
                opts.sVivaToken
            );
        }
    }
}
